import React, { Component } from 'react';
import { CAMPAIGN_CONTACT_LIST_API } from '../../../constants/ServiceConstants';
import api from '../../../axios/Axios';
import DashboardLayout from '../../UI/Layout/DashboardLayout';
import Title from '../../UI/Text/Title';
import AdvanceDataTable from '../../UI/Table/AdvanceDataTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { NODE_HOST_URL } from '../api/Api';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import styles from "./ViewContactList.module.css";

class ViewContactList extends Component {
  constructor(props) {
    super(props);

    const lStorage = JSON.parse(localStorage.getItem("login"));
    if (!lStorage || !lStorage.user) {
      window.location.href = "/login";
      return;
    }

    const user_id = lStorage.user.userId;
    const token = lStorage.token;

    this.state = {
      userId: user_id,
      token: token,
      ContactListData: [],
      filterContact: '',
      setIsLoading: true,
      ErrorResponse: '',
      id: this.props.match.params.id,
      type: this.props.match.params.list_type,
      list_name: this.props.match.params.list_name
        ? decodeURIComponent(this.props.match.params.list_name)
        : "",
      openPopup: false,
      selectedContact: {},
      contactDetails: [],
      contactDetailPopup: false,
      mobileNumber: ''
    };
  }

  customTableStyles = {
    rows: { style: { minHeight: '48px' } },
    headCells: {
      style: {
        background: '#3f3966',
        color: '#fff',
        padding: '10px 12px',
        fontWeight: '600',
        fontSize: '13px',
      },
    },
    cells: {
      style: {
        color: '#2d2d2d',
        lineHeight: '1.5',
        padding: '8px 12px',
        fontSize: '13px',
      },
    },
    table: { style: { width: '100%', tableLayout: 'fixed' } },
    tableWrapper: { style: { width: '100%' } },
  };

  CONTACT_LIST_COLUMNS = [
    {
      name: 'Mobile',
      cell: (row) => (
        <Link
          style={{ textDecoration: 'none', fontWeight: 600, color: '#6b46c1' }}
          to={
            this.state.type !== 'contact'
              ? `/dashboard/view-contact-list/${this.state.id}/${this.state.type}/${row.mobile}/${row._id}`
              : '#'
          }
        >
          {row.mobile}
        </Link>
      ),
      sortable: true,
      width: '25%',
    },
    {
      name: 'Email',
      cell: (row) => row.email || row.email_id || '—',
      sortable: true,
      width: '35%',
    },
    {
      name: 'Date Time',
      cell: (row) => this.formatDate(row.created),
      sortable: true,
      width: '30%',
    },
    {
      name: 'View',
      cell: (row) => (
        <button
          className={styles.actionBtn}
          onClick={() => this.openModal(row)}
          title="View Details"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
      width: '10%',
      center: true,
    },
  ];

  componentDidMount() {
    this.getContactList();
  }

  getContactList = async () => {
    try {
      const { data } = await api.post(`${NODE_HOST_URL}/contact_list`, {
        token: this.state.token,
        user_id: this.state.userId,
        list_id: this.state.id,
        method: 'list_data',
        list_type: this.state.type,
      });

      if (data.success === true) {
        const newArray = data.data.map(item => ({
          ...item,
          list_type: this.state.type,
        }));
        this.setState({ ContactListData: newArray, setIsLoading: false });
      } else {
        this.setState({ ErrorResponse: data, setIsLoading: false });
      }
    } catch (err) {
      console.log(err);
    }
  };

  filterData = async () => {
    this.setState({ isError: false });
    try {
      const { data } = await api.post(CAMPAIGN_CONTACT_LIST_API, {
        token: this.state.token,
        user_id: this.state.userId,
        method: "filter",
        list_id: this.state.id,
        mobile: this.state.filterContact,
      });
      if (data.success === true) {
        this.setState({ ContactListData: data.data, setIsLoading: false, searchDataTable: true });
      } else {
        this.setState({ errorMessage: data.message, isError: true, messageType: 'alert-danger', setIsLoading: false });
      }
    } catch (err) {
      console.log(err);
    }
  };

  resetFilter = () => {
    this.getContactList();
    this.setState({
      searchDataTable: false,
      filterContact: '',
    });
  };


  openModal = (contact) => {
    console.log(contact);

    this.setState({ selectedContact: contact, openPopup: true });
  };


  closeModal = () => {
    this.setState({ openPopup: false, selectedContact: null });
  };






  formatDate = (dateStr) => {
    if (!dateStr) return "—";
    try {
      return new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }).format(new Date(dateStr));
    } catch {
      return dateStr;
    }
  };

  render() {
    return (
      <DashboardLayout>
        <main className="content">
          <div className="container-fluid p-0">
            <Title
              isButton={true}
              btnName={`Back`}
              actionURL={`/dashboard/contact-list`}
            >
              {this.state.list_name
                ? this.state.list_name
                : `Contact List #${this.state.id}`}
            </Title>

            <div className={styles.tableCard}>
              <AdvanceDataTable
                tableName={this.state.list_name || `Contact List #${this.state.id}`}
                tableCell={this.CONTACT_LIST_COLUMNS}
                tableData={this.state.ContactListData}
                isLoading={this.state.setIsLoading}
                isError={this.state.ErrorResponse}
                containerClass={styles.fullWidthTable}
                customStyles={this.customTableStyles}
                pagination={true}
                paginationPerPage={50}
              />
            </div>

            {this.state.openPopup && (
              <div className={styles.modalOverlay} onClick={this.closeModal}>
                <div
                  className={styles.modalBox}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Header */}
                  <div className={styles.modalHeader}>
                    <div className={styles.modalTitle}>
                      Contact Details
                      {this.state.selectedContact?.firstname && (
                        <span className={styles.modalNameBadge}>
                          {this.state.selectedContact.firstname}
                        </span>
                      )}
                    </div>
                    <button
                      className={styles.modalCloseBtn}
                      onClick={this.closeModal}
                      aria-label="Close"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2.5"
                        strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 6 6 18M6 6l12 12"/>
                      </svg>
                    </button>
                  </div>

                  {/* Body */}
                  <div className={styles.modalBody}>
                    {Object.entries(this.state.selectedContact ?? {})
                      .filter(([key]) => !["_id", "user_id"].includes(key))
                      .map(([key, value], j) => (
                        <div key={j} className={styles.detailRow}>
                          <span className={styles.detailKey}>{key}</span>
                          <span className={styles.detailValue}>
                            {value !== null && typeof value === "object" ? (
                              <div className={styles.nestedGroup}>
                                {Object.entries(value ?? {}).map(([subKey, subVal], k) => (
                                  <div key={k} className={styles.nestedRow}>
                                    <span className={styles.nestedKey}>{subKey}:</span>
                                    <span>{subVal}</span>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              ["created", "createdat", "updated_at", "updatedat"].includes(key.toLowerCase())
                              ? this.formatDate(value)
                              : (value ?? <span className={styles.emptyVal}>—</span>)
                            )}
                          </span>
                        </div>
                      ))}
                  </div>

                  {/* Footer */}
                  <div className={styles.modalFooter}>
                    <button className={styles.closeBtn} onClick={this.closeModal}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            {this.state.contactDetailPopup && (
              <div
                className={`modal fade ${this.state.contactDetailPopup ? "show" : ""
                  }`}
                style={{
                  display: this.state.contactDetailPopup ? "block" : "none",
                }}
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Billing Information for {this.state.mobile}
                      </h5>
                    </div>
                    <div
                      className="modal-body"
                      style={{ maxHeight: "400px", overflowY: "auto" }}
                    >
                      <div className="list-group">
                        {this.state.contactDetails.map((x, index) => (
                          <div key={index} className="list-group-item">
                            {Object.keys(x.billingDetails).map((key, idx) => (
                              <div key={idx}>
                                <h5 className="mb-3">{key}</h5>
                                {x.billingDetails[key].map((item, i) => (
                                  <div key={i} className="d-flex flex-column">
                                    {Object.entries(item).map(
                                      ([billingKey, billingValue], j) => (
                                        <div
                                          key={j}
                                          className="d-flex justify-content-between align-items-center mb-2"
                                        >
                                          <span className="font-weight-bold">
                                            {billingKey}:
                                          </span>
                                          <span>{billingValue}</span>
                                        </div>
                                      )
                                    )}
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() =>
                          this.setState({ contactDetailPopup: false })
                        }
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* <AdvanceDataTable
              tableName={'List Data'}
              tableCell={CAMPAIGN_CONTACT_DATA}
              tableData={this.state.ContactListData}
              isLoading={this.state.setIsLoading}
              isError={this.state.ErrorResponse}
            /> */}
          </div>
        </main>
      </DashboardLayout>
    );
  }
}

export default ViewContactList;
